export const ERRORMESSAGE = {
  firstNameRequired: 'Merci de compléter cette information',
  lastNameRequired: 'Merci de compléter cette information',
  city: 'Ne doit pas depasser les 38 caracters',
  cityRequired: 'Merci de compléter cette information',
  codePostal: 'Merci de vérifier votre saisie',
  codePostalRequired: 'Merci de compléter cette information',
  street: 'Merci de compléter cette information',
  streetRequired: 'Merci de compléter cette information',
  streetNumber: 'Ce champs ne doit pas contenir des caractères spéciaux',
  email: 'Merci de vérifier votre saisie ',

  phone: 'Merci de vérifier votre saisie ',
  phoneRequired: 'Merci de compléter cette information',
};

export const ERRORMESSAGEMOBILE = {
  firstName: { label: 'prenom', message: 'Merci de compléter cette information' },
  lastName: { label: 'nom', message: 'Merci de compléter cette information' },
  iban: { label: 'iban', message: 'Merci de compléter cette information' },
  titulaire: { label: 'titulaire', message: 'Merci de compléter cette information' },
  ibanFormat: { label: 'ibanFormat', message: 'error lors de saisie IBAN' },
};

export const returnComponenet = {
  FIRST: 'first Componet',
  EMPTY: 'empty search value',
  'ARRAY-RESULT': 'array result',
};
